export default __webpack_public_path__ + "8a6820ceae658dbad45770a0db0acba2.png";